import { motion } from "framer-motion";
import { Crown } from "lucide-react";
import { Link } from "react-router-dom";

export default function AuthShell({ title, sub, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#050505] px-4 py-16">
      <div className="grain-overlay" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background: "radial-gradient(ellipse 55% 45% at 50% 0%, rgba(212,175,55,0.08), transparent 70%)",
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md"
      >
        <Link to="/" data-testid="auth-home-link" className="mb-10 flex items-center justify-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10">
            <Crown className="h-4 w-4 text-[#D4AF37]" strokeWidth={1.5} />
          </span>
          <span className="leading-tight">
            <span className="block font-serif text-xl font-semibold tracking-wide text-white">KINGDOM</span>
            <span className="block text-[10px] font-medium uppercase tracking-[0.28em] text-zinc-500">
              Partnership Blueprint
            </span>
          </span>
        </Link>
        <div className="border border-[#27272A] bg-[#0A0A0A] p-8 sm:p-10">
          <h1 className="font-serif text-2xl font-semibold text-white">{title}</h1>
          {sub && <p className="mt-2 text-sm text-zinc-500">{sub}</p>}
          <div className="mt-8">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-zinc-500">{footer}</div>}
      </motion.div>
    </div>
  );
}
